export default "__VITE_PUBLIC_ASSET__d81b9770__"